import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../components/Main.css";
import useApiRequest from "../hooks/useApiRequest";
import Spinner from "./shared/spinner";

const Main = ({ changeBanner }) => {
  const navigate = useNavigate();
  const {
    data: vehicleTypes,
    isLoading,
    error,
  } = useApiRequest(`/vehicle-types`);

  useEffect(() => {
    changeBanner(false);
  }, []);

  const handleCardClick = (id) => {
    navigate(`/${id}`);
  };

  if (isLoading) {
    return <Spinner />;
  }

  // Get the allowed vehicle type IDs from the window object
  const allowedVehicleTypeIds = (window.ALLOWED_VEHICLE_TYPE_IDS ?? "")
    .split(",")
    .filter(Boolean)
    .map(Number);

  // Filter the vehicle types based on the allowed IDs, or use all vehicle types if no IDs are allowed
  const filteredVehicleTypes =
    allowedVehicleTypeIds.length > 0
      ? vehicleTypes.filter((vehicleType) =>
          allowedVehicleTypeIds.includes(vehicleType.id)
        )
      : vehicleTypes;

  return (
    <div>
      <h1
        className="flex items-center justify-center mt-12 mb-6 font-bold text-center text-2xl sm:text-4xl"
        style={{ color: "#121212" }}
      >
        Select the Type of Vehicle
      </h1>
      <div className="container mx-auto mt-8 flex flex-wrap justify-center">
        {filteredVehicleTypes.map((card, index) => (
          <div
            key={index}
            className="max-w-xs mx-4 mb-8 bg-white shadow-xl rounded-md overflow-hidden mainCards"
            onClick={() => handleCardClick(card.name)}
          >
            <div
              className="p-4 flex flex-col items-center"
              style={{ width: "250px" }}
            >
              <img
                src={card.icon_url}
                alt={`Card ${index + 1}`}
                className="w-24 h-24 mb-2"
              />
              <p className="text-lg font-semibold">{card.display_name}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Main;
